// estados por defectos para mensajes (varaibles globales en el store  de mensajeria)
export default{
    // para sirve para acceder  mapstate de la siguiente forma para lso modulos ...(mapState 'mensaje', ['mensaje'])
    namespaced :true,

    state : {
        searchProduct:'',
        categoria: {}, // marca
        linea: {}
    },
    // cambia los estados de las variables principales
    // de las variables princiaples

    mutations : {

        loadingEventMenu(state, payload) {
            // console.log("mutations:" + JSON.stringify(payload))
            if(payload.origin == "categoria"){
                state.categoria = payload
            }

            if(payload.origin == "linea"){
                state.linea = payload
            }
            // state.ancho = ( (payload.ancho == null) || (payload.ancho == "") ) ? "300" : payload.color 
          },


        
          
          deleteEventMenu(state, payload){

            if(payload.origin == "categoria"){
                state.categoria = {}
            }

            if(payload.origin == "linea"){
                state.linea = {}
            }
          },
          

          searchProduct(state, value) {
            // console.log("mutations:" + JSON.stringify(payload))
                state.searchProduct = value
            
            // state.ancho = ( (payload.ancho == null) || (payload.ancho == "") ) ? "300" : payload.color 
          },

                    
        deleteSearchProduct(state){
            state.searchProduct = null
        },


    },

    

    // crea una copía de los estado iniciales del store (state)
    getters : {},
    actions : {}
}

/*
    ////////////////////////
    ////  Uso        ///
    /////////////////////////


    import {mapMutations} from 'vuex'
    import { mapState, mapMutations } from "vuex";
  ...mapMutations('eventMenu', ['loading', 'delete']),
    computed: {
    ...mapState("eventMenu", ["categoria",  "linea"]),  
    },
    methods: {
             enviarMensaje() {
            
     async loadMain(){
                try{
               
                    // Simple ó  
                    this.viewLoading({});
                     // full 
                    this.viewLoading( {
                        titulo: "",
                        color: "#fff",
                        colorDialog: "#212121",
                        ancho: 300,
                    }); 
                    
                    let params ={id_empresa: this.session.id_empresa, limit:true }
                    let response = await axios.post("/agremiado/agremiado/getView",{filtro:params})
                    this.Datos   = response.data
                    this.closeLoading()

                }
                catch(e){
                    if (e.response) {
                        let resp = e.response.data
                        this.closeLoading()
                        console.log(resp)
                        this.setEnviarMens({tipo:resp.messageT, mensaje: `${resp.message}`, tiempo:null})                        
                    }
                }
            },


            },
*/